var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.category)?_c('div',{staticClass:"empty"},[_vm._v("暂无 “"+_vm._s(_vm.props.category.name)+"” 相关的商品...")]):_c('div',{staticClass:"empty"},[_vm._v("暂无相关的商品...")])}
var staticRenderFns = []

export { render, staticRenderFns }